import axios from 'axios'
import BaseRequest from './BaseRequest'

export default class ShopRequest extends BaseRequest {
  getList() {
    return axios.get(`${this.baseUrl}/admin/shops/`)
  }

  getById(id) {
    return axios.get(`${this.baseUrl}/admin/shops/?shopId=${id}`)
  }

  getQrById(id) {
    return axios.get(`${this.baseUrl}/admin/shops/qr/${id}`)
  }

  changeQr(id, seatNo) {
    if (seatNo !== undefined) {
      return axios.post(`${this.baseUrl}/admin/shops/qr/update/${id}/${seatNo}`)
    } else {
      return axios.post(`${this.baseUrl}/admin/shops/qr/update/${id}`)
    }
  }

  insert(params) {
    return axios.post(`${this.baseUrl}/admin/shops/insert/`, params)
  }

  update(id, params) {
    return axios.post(`${this.baseUrl}/admin/shops/update/${id}`, params)
  }

  delete(id, params) {
    return axios.post(`${this.baseUrl}/admin/shops/delete/${id}`, params)
  }

  getGroups() {
    return axios.get(`${this.baseUrl}/admin/shops/groups/`)
  }

  addGroup(params) {
    return axios.post(`${this.baseUrl}/admin/shops/groups/add/`, params)
  }

  deleteGroup(groupId, shopId) {
    return axios.post(
      `${this.baseUrl}/admin/shops/groups/delete/${groupId}/${shopId}`
    )
  }
}
